import React, { useState } from "react";
import { toast } from "react-toastify";

import useContract from "../../hooks/useContract";


const Admin = () => {


const {

startLeague,
autoStartNextLeague,
finalizeLeague,
emergencyEndLeague,

depositRewardPool,

setGlobalTradingGoal,
setKpPerUsd500,
setClaimExpiry,
setVisibleLeaderboardSize,

setTierMinimums,
setRewardDistribution,

pauseContract,
unpauseContract,

address,
isConnected

} = useContract();



const [loading,setLoading] = useState(false);



const [form,setForm] = useState({

startAt:"",
endAt:"",
leaderboard:50,

rewardAmount:"",

globalGoal:"1000000",

kp500:"10",

claimExpiry:"2592000",

tier1:10,
tier2:50,
tier3:100,


tier1Reward:5000,
tier2Reward:3000,
tier3Reward:2000

});



const update=(key,value)=>{

setForm(prev=>({
...prev,
[key]:value
}));

};




const execute = async(fn)=>{

try{

setLoading(true);


await fn();


toast.success(
"Transaction successful"
);


}catch(error){

console.log(error);

toast.error(
error.message ||
"Transaction failed"
);


}
finally{

setLoading(false);

}

};






const startLeagueHandler = ()=>{


const start =
form.startAt
?
Number(form.startAt)
:
Math.floor(Date.now()/1000);



const end =
form.endAt
?
Number(form.endAt)
:
start + 2592000;



execute(
()=>startLeague(
start,
end,
Number(form.leaderboard)
)
);


};






return (

<div className="
min-h-screen
bg-[#080808]
text-white
p-6
md:p-10
">


<h1 className="
text-3xl
font-black
text-[#ffcc66]
mb-2
">

KTL ADMIN PANEL

</h1>


<p className="
text-gray-500
mb-8
font-mono
text-sm
">

{address}

</p>




<div className="
grid
gap-6
lg:grid-cols-2
">





{/* LEAGUE CONTROL */}

<section className="
bg-[#141414]
border
border-white/10
rounded-xl
p-6
">


<h2 className="
text-xl
font-bold
mb-5
text-[#ffcc66]
">

League Control

</h2>



<input

className="input"

placeholder="Start Timestamp"

value={form.startAt}

onChange={
e=>update(
"startAt",
e.target.value
)
}

/>


<input

className="input"

placeholder="End Timestamp"

value={form.endAt}

onChange={
e=>update(
"endAt",
e.target.value
)
}

/>



<input

className="input"

placeholder="Leaderboard Size"

value={form.leaderboard}

onChange={
e=>update(
"leaderboard",
e.target.value
)
}

/>



<button

disabled={loading}

onClick={
startLeagueHandler
}

className="btn"

>

Start League

</button>



<button

disabled={loading}

onClick={()=>
execute(
()=>autoStartNextLeague(
Number(form.leaderboard)
)
)
}

className="btn"

>

Auto Start Next League

</button>



<button

disabled={loading}

onClick={()=>
execute(
finalizeLeague
)
}

className="btn"

>

Finalize League

</button>



<button

disabled={loading}

onClick={()=>
execute(
emergencyEndLeague
)
}

className="btn danger"

>

Emergency End League

</button>


</section>








{/* REWARD */}

<section className="
bg-[#141414]
border
border-white/10
rounded-xl
p-6
">


<h2 className="
text-xl
font-bold
mb-5
text-[#ffcc66]
">

Reward Settings

</h2>



<input

className="input"

placeholder="Reward Token Amount"

value={form.rewardAmount}

onChange={
e=>update(
"rewardAmount",
e.target.value
)
}

/>


<button

className="btn"

disabled={loading}

onClick={()=>

execute(
()=>depositRewardPool(
form.rewardAmount
)
)

}

>

Deposit Reward Pool

</button>



<input

className="input"

placeholder="Global Trading Goal USD"

value={form.globalGoal}

onChange={
e=>update(
"globalGoal",
e.target.value
)
}

/>


<button

className="btn"

onClick={()=>

execute(
()=>setGlobalTradingGoal(
form.globalGoal
)
)

}

>

Set Global Goal

</button>





<input

className="input"

placeholder="KP per $500"

value={form.kp500}

onChange={
e=>update(
"kp500",
e.target.value
)
}

/>


<button

className="btn"

onClick={()=>

execute(
()=>setKpPerUsd500(
form.kp500
)
)

}

>

Set KP Rule

</button>



</section>








{/* CONFIG */}

<section className="
bg-[#141414]
border
border-white/10
rounded-xl
p-6
">


<h2 className="
text-xl
font-bold
mb-5
text-[#ffcc66]
">

League Configuration

</h2>



<input

className="input"

placeholder="Claim Expiry Seconds"

value={form.claimExpiry}

onChange={
e=>update(
"claimExpiry",
e.target.value
)
}

/>



<button

className="btn"

onClick={()=>

execute(
()=>setClaimExpiry(
form.claimExpiry
)
)

}

>

Set Claim Expiry

</button>





<input

className="input"

placeholder="Visible Leaderboard"

value={form.leaderboard}

onChange={
e=>update(
"leaderboard",
e.target.value
)
}

/>



<button

className="btn"

onClick={()=>

execute(
()=>setVisibleLeaderboardSize(
form.leaderboard
)
)

}

>

Set Leaderboard Size

</button>




<div className="grid grid-cols-3 gap-3">


<input
className="input"
value={form.tier1}
onChange={
e=>update(
"tier1",
e.target.value
)
}
/>


<input
className="input"
value={form.tier2}
onChange={
e=>update(
"tier2",
e.target.value
)
}
/>


<input
className="input"
value={form.tier3}
onChange={
e=>update(
"tier3",
e.target.value
)
}
/>


</div>



<button

className="btn"

onClick={()=>

execute(
()=>setTierMinimums(
form.tier1,
form.tier2,
form.tier3
)
)

}

>

Set Tier Minimums

</button>




</section>









{/* SECURITY */}

<section className="
bg-[#141414]
border
border-white/10
rounded-xl
p-6
">


<h2 className="
text-xl
font-bold
mb-5
text-[#ffcc66]
">

Security

</h2>



<button

className="btn danger"

onClick={()=>

execute(
pauseContract
)

}

>

Pause Contract

</button>




<button

className="btn"

onClick={()=>

execute(
unpauseContract
)

}

>

Unpause Contract

</button>



</section>





</div>






<style jsx>{`

.input{

width:100%;
background:#080808;
border:1px solid #333;
padding:12px;
border-radius:10px;
margin-bottom:12px;
color:white;

}


.btn{

width:100%;
background:#ffcc66;
color:#111;
font-weight:800;
padding:12px;
border-radius:10px;
margin-bottom:12px;
cursor:pointer;

}


.btn:hover{

opacity:.85;

}


.danger{

background:#ff5555;
color:white;

}

`}</style>



</div>

);

};


export default Admin;